import { Grid, List } from '@mui/material';
import { IDataProdutosPedidos } from '../../../../../../../../types/api/comercial/pedidos-pesquisar-produtos';
import React from 'react';
import { ProdutoCard } from './ProdutoCard';
import { ProdutoListItem } from './ProdutoListItem';

export interface ProdutosListagemProps {
    produtos: IDataProdutosPedidos[];
    viewMode: 'grid' | 'list';
    handleAddClick: (produto: IDataProdutosPedidos) => void;
    publico_fazendeiro: boolean;
}

export function ProdutosListagem({ produtos, viewMode, handleAddClick, publico_fazendeiro }: ProdutosListagemProps) {
    if (viewMode === 'grid') {
        return (
            <Grid container spacing={2}>
                {produtos.map((produto) => (
                    <Grid size={{xs: 12, sm: 6, md: 4, lg: 3}} key={produto.id}>
                        <ProdutoCard 
                            produto={produto} 
                            handleAddClick={handleAddClick} 
                            publico_fazendeiro={publico_fazendeiro} 
                        />
                    </Grid>
                ))}
            </Grid>
        );
    } 

    if (viewMode === 'list') {
        return (
            <List sx={{ width: '100%' }}>
                {produtos.map((produto) => (
                    <ProdutoListItem 
                        key={produto.id}
                        produto={produto} 
                        handleAddClick={handleAddClick} 
                        publico_fazendeiro={publico_fazendeiro} 
                    />
                ))}
            </List>
        );
    }

    return <React.Fragment />;
}